import StoreList from "common/Management-store/StoreList";
import { useState, useEffect } from "react";
import about from "assets/images/about.png";
import BtnPage from "common/Management-store/BtnPage";
import AddStoreModal from "common/Management-store/AddStorModal";
import EditStoreModal from "common/Management-store/EditStoreModal";
import FilterStoreModal from "common/Management-store/FilterStoreModal";
import Pagination from "rc-pagination";
import sendRequest from "hooks/useAxios";
import toast from "react-hot-toast";
import toastFunction from "utils/toast";
import axios from "axios";
import Loader from "utils/Loader";
import { MdStorefront } from "react-icons/md";
import Title from "common/Title";
import logoGM from "assets/images/sitelogo.svg";
import { Helmet } from "react-helmet";

export default function ManagmentStore({ logo }) {
  const [showStoreModal, setShowStoreModal] = useState(false);
  const [showEditStoreModal, setShowEditStoreModal] = useState(false);
  const [isLoding, setIsLoading] = useState(true);

  const [informationStore, setInformationStore] = useState([]);
  console.log("managmentStore", informationStore);
  const [selectedItem, setSelectedItem] = useState({});
  const [forceUpdate, setForceUpdate] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const toastCustome = (message) => {
    return toast.custom(
      <div
        className="d-flex  "
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          padding: "10px",
        }}
      >
        <div>
          <img style={{ width: "40px" }} src={logoGM}></img>
        </div>
        <div style={{ alignSelf: "center", marginRight: "5px" }}>{message}</div>
      </div>
    );
  };
  useEffect(() => {
    //get store
    async function LoadPage() {
      await sendRequest("Find_businesses", {
        tbl_name: "left join,files,logo_file_id,id",
        conditions: "status/!=/-1",
      }).then(({ data }) => {
        console.log("dataa", data);

        setInformationStore(data);
      });
      setIsLoading(false);
    }
    LoadPage();
  }, [forceUpdate]);
  console.log("*", informationStore);
  // مسدود کردن  ورفع مسدودیت فروشکاه api
  const stopHandler = (id, activeBusiness) => {
    //setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("business_id", id);
    if (activeBusiness == "0") {
      myFormData.append("activate", 0);
    } else if (activeBusiness == "-2") {
      myFormData.append("activate", 1);
    }
    axios
      .post(
        `http://marketgroup.tatdemo.ir/api2/business_activation`,
        myFormData
      )
      .then((res) => {
        if (res.data.status == 1) {
          if (activeBusiness == "0") {
            toastFunction("success", "فروشگاه باموفقیت متوقف شد.");

            // toast.success("  فروشگاه با موفقیت متوقف شد");
          } else if (activeBusiness == "-2") {
            toastFunction("success", "فروشگاه باموفقیت فعال شد.");

            // toast.success("  فروشگاه با موفقیت فعال شد");
          }
          setForceUpdate((prev) => !prev);

          console.log("id", id);

          // setIsLoading(false);
          // setUpdater(!updater);
        } else {
          toastFunction("error", "عملیات با خطا مواجه شد");

          // toast.success("عملیات با خطا مواجه شد");

          console.log("id", id);

          // setIsLoading(false);
        }
      });
  };

  //حذف فروشگاه
  const deletepHandler = (id) => {
    //setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("business_id", id);
    axios
      .post(
        `http://marketgroup.tatdemo.ir/api2/business_activation`,
        myFormData
      )
      .then((res) => {
        if (res.data.status == 1) {
          toastFunction("success", "فروشگاه باموفقیت حذف شد");

          // toast.success("  فروشگاه با موفقیت حذف شد");
          setForceUpdate((prev) => !prev);

          console.log("id", id);

          // setIsLoading(false);
          // setUpdater(!updater);
        } else {
          toastFunction("error", "خطادر حذف فروشگاه!");

          // toast.error("  خطا در حذف کردن  فروشگاه!");
          console.log("id", id);

          // setIsLoading(false);
        }
      });
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`مدیریت فروشگاه`} </title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>
      {isLoding && <Loader></Loader>}
      <Title
        color="rgb(244 124 96)"
        title="مدیریت فروشگاهها"
        icon={MdStorefront}
      />
      <div className="parentManagmentStore">
        <div className="">
          <AddStoreModal
            setForceUpdate={setForceUpdate}
            setShowStoreModal={setShowStoreModal}
            showStoreModal={showStoreModal}
          ></AddStoreModal>
          <EditStoreModal
            selectedItem={selectedItem}
            setForceUpdate={setForceUpdate}
            setShowEditStoreModal={setShowEditStoreModal}
            showEditStoreModal={showEditStoreModal}
          ></EditStoreModal>
          <FilterStoreModal
            informationStore={informationStore}
            setForceUpdate={setForceUpdate}
            setInformationStore={setInformationStore}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          ></FilterStoreModal>
          <BtnPage setShowStoreModal={setShowStoreModal}></BtnPage>
        </div>

        <>
          {informationStore != undefined || informationStore.length > 0 ? (
            <>
              {[...informationStore]
                ?.reverse()
                ?.slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
                .map((val, index) => {
                  return (
                    <div className="container con-style">
                      <StoreList
                        informationStore={informationStore}
                        setInformationStore={setInformationStore}
                        val={val}
                        index={index}
                        setSelectedItem={setSelectedItem}
                        stopHandler={stopHandler}
                        deletepHandler={deletepHandler}
                        setShowEditStoreModal={setShowEditStoreModal}
                        showEditStoreModal={showEditStoreModal}
                      ></StoreList>
                    </div>
                  );
                })}
            </>
          ) : (
            ""
          )}
        </>
        {informationStore.length > 0 ? (
          <div className="d-flex justify-content-center mt-4">
            <div>
              <Pagination
                total={informationStore.length}
                pageSize={5}
                current={currentPage}
                onChange={(newPage) => {
                  setCurrentPage(newPage);
                }}
              ></Pagination>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center mt-4">
            <h3>فروشگاهی پیدا نشد !</h3>
          </div>
        )}
      </div>
    </>
  );
}
